export var MAIN_PANEL_MIN_HEIGHT = 250; // approximate height of breadcrumb, table header, and the first table row
/**
 * Estimate a default split panel size for the first render based on the document size.
 */
export function getSplitPanelDefaultSize(position) {
    if (typeof document === 'undefined') {
        return 0; // render the split panel in its minimum possible size
    }
    return position === 'side' ? document.documentElement.clientWidth / 3 : document.documentElement.clientHeight / 2;
}
//# sourceMappingURL=get-default-size.js.map